export default "__VITE_ASSET__Dk5ci$BS__"